import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { ProgramsIcon, DashboardIcon } from '@shared/ui/icons';

const Programs = lazy(() => import('@pages/programs'));
const ProgramDashboard = lazy(() => import('@pages/program-dashboard'));

// Services ("programs" in code) have their own permission bits since
// 2026-09-17 (API branch feature/services-own-permissions): the list is
// guarded by SERVICES_GET and a single service by SERVICE_GET. They are
// role-granted to every account, with no account switch — Services do
// NOT follow the Programs module (PR 2488 tied them to PROGRAMS_GET
// while the API still did; that gate is gone). In a DS child context the
// route gate also accepts the child mask (isRoutePermitted).
const PROGRAM_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/programs',
  exact: true,
  additional: {
    component: Programs,
    protected: true,
    title: i18next.t('titles:programs'),
    icon: ProgramsIcon,
    permission: permissions.SERVICES_GET,
  },
};

const PROGRAM_ROUTE_DASHBOARD_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/programs/:programUuid/:tableName/list',
  exact: true,
  parentRoute: PROGRAM_ROUTE_LIST_DS,
  additional: {
    component: ProgramDashboard,
    protected: true,
    title: i18next.t('titles:programDashboard'),
    icon: DashboardIcon,
    permission: permissions.SERVICE_GET,
  },
};

const PROGRAM_ROUTE_LIST = {
  path: '/:currentAccountUuid/programs',
  exact: true,
  additional: {
    component: Programs,
    protected: true,
    title: i18next.t('titles:programs'),
    icon: ProgramsIcon,
    permission: permissions.SERVICES_GET,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.programs || 'Services',
    },
  },
};

const PROGRAM_ROUTE_DASHBOARD = {
  path: '/:currentAccountUuid/patients/:patientUuid/programs/:programUuid/:tableName/list',
  exact: true,
  parentRoute: PROGRAM_ROUTE_LIST,
  additional: {
    component: ProgramDashboard,
    protected: true,
    title: i18next.t('titles:programDashboard'),
    icon: DashboardIcon,
    permission: permissions.SERVICE_GET,
  },
};

export const PROGRAM_ROUTES = {
  // ------- For child accounts ------
  listDS: PROGRAM_ROUTE_LIST_DS,
  dashboardDS: PROGRAM_ROUTE_DASHBOARD_DS,

  // ------- For current accounts ------
  list: PROGRAM_ROUTE_LIST,
  dashboard: PROGRAM_ROUTE_DASHBOARD,
};
